export enum TealiumErrorContext {
  API = 'API',
  STREAM = 'ST',
  DEEPLINK = 'DL',
  PAUSEAD = 'RE',
}

export enum TealiumErrorCode {
  // API
  OztamPostRequest = 'OztamPostRequest',
  FetchAdobeECID = '10PlayFetchAdobeECID',
  FetchPauseAd = '10PlayFetchPauseAd',
  FetchUser = '10PlayFetchUser',
  FetchVideoMetadata = '10PlayFetchVideoMetadata',
  FetchVideoPlayback = '10PlayFetchVideoPlayback',
  FetchLiveTv = '10PlayFetchLiveTv',
  FetchNews = '10PlayFetchNews',
  FetchShow = '10PlayFetchShow',
  FetchActivationCode = '10PlayFetchActivationCode',
  FetchWatchHistory = '10PlayFetchWatchHistory',
  FetchMyShow = '10PlayFetchMyShow',
  PostMyShow = '10PlayPostMyShow',
  FetchAppConfig = '10PlayFetchAppConfig',
  RefreshToken = '10PlayRefreshToken',
  GeneralGetRequest = '10PlayGetRequest',
  GeneralPostRequest = '10PlayPostRequest',

  // STREAM
  DaiLive = 'DaiLive',
  Dai = 'Dai',
  Hls = 'Hls',
  Dash = 'Dash',

  // DEEPLINK
  DLShow = 'Show',
  DLVideo = 'Video',
  DLLiveVideo = 'LiveVideo',
  DLLiveTV = 'LiveTV',

  // PAUSEAD
  PauseAdFetch = 'Fetch',
}

export type TealiumErrorData = {
  errorCode: TealiumErrorCode;
  errorMessage: string;
  errorContext: TealiumErrorContext;
  errorDetail: string;
  errorSource: string;
};
